import React, { FC, useContext } from "react";
import { ConfirmDialog, useNotifications, WarningMessage } from "sprint-common-web";

import { useFileRecordApi } from "../../../../../common/api/master-api/file-records/useFileRecordApi";
import { FileRecordStatus } from "../../../../../common/types/FileRecordStatus";
import { FileRecordListingContext } from "../../context/FileRecordListingContext";

type DestroyFileRecordListingDialogProps = {
    onClose(): void;
    isOpen: boolean;
    itemId: string;
};

export const DestroyFileRecordListingDialog: FC<DestroyFileRecordListingDialogProps> = ({
    itemId,
    isOpen,
    onClose
}) => {
    const { success, error } = useNotifications();
    const { updateFileRecordStatus } = useContext(FileRecordListingContext);

    const { destroyFileRecord } = useFileRecordApi();

    const handleConfirm = async () => {
        try {
            await destroyFileRecord({
                fileRecordId: itemId
            });
            updateFileRecordStatus(itemId, FileRecordStatus.Destroyed);
            success("File record successfully destroyed.");
        } catch {
            error("Failure during destroying file record.");
        }

        onClose();
    };

    return (
        <ConfirmDialog
            title="Destroy file record"
            text="Are you sure you want to destroy this file record?"
            confirm={{ onClick: handleConfirm }}
            cancel={{ onClick: onClose }}
            hidden={!isOpen}
        >
            <WarningMessage message="Destroying this file record is irreversible. All associated assets will be deprecated. Please confirm you want to proceed." />
        </ConfirmDialog>
    );
};
